import { apiConfig } from '../config/apiConfig';
import { refreshTokensIfNeeded, getAuthorizationHeader, isAuthenticated } from './auth';

async function historyFetch(endpoint, { method = 'GET', body = null, params = {} } = {}) {
  await refreshTokensIfNeeded();

  const authHeader = getAuthorizationHeader();
  if (!authHeader) {
    throw new Error('Not authenticated');
  }

  const baseUrl = apiConfig.historyApi;
  if (!baseUrl) {
    throw new Error('History API endpoint not configured');
  }

  const queryString = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

  const url = `${baseUrl}/${endpoint}${queryString ? `?${queryString}` : ''}`;

  const headers = {
    'Authorization': authHeader,
    'Content-Type': 'application/json',
  };

  const options = { method, headers };
  if (body && method !== 'GET') {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error(`History API error: ${response.status}`);
  }

  return response.json();
}

const MAPBOX_TOKEN = 'pk.eyJ1IjoidmFyaWsiLCJhIjoiY2tlZGQxejhnMGEzczJ6a2ZjdnMxcGo5NyJ9.jCdGWqxlTtpyc_PV0qnuPA';

async function reverseGeocode(lat, lng) {
  try {
    const resp = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_TOKEN}&limit=1&types=place,locality,neighborhood`
    );
    const data = await resp.json();
    if (data.features && data.features.length > 0) {
      return data.features[0].place_name || '';
    }
  } catch (e) {
    // Ignore — location_name is optional
  }
  return '';
}

export async function savePlace({ lat, lng, zoom, bbox, location_name }) {
  if (!isAuthenticated()) return;
  try {
    let name = location_name || '';
    if (!name && lat != null && lng != null) {
      name = await reverseGeocode(lat, lng);
    }
    await historyFetch('places', {
      method: 'POST',
      body: { lat, lng, zoom, bbox, location_name: name },
    });
  } catch (e) {
    console.warn('Failed to save place to history:', e.message);
  }
}

export async function fetchPlaces(limit = 50, offset = 0) {
  return historyFetch('places', { params: { limit, offset } });
}

export async function fetchSrImages(limit = 50, offset = 0) {
  return historyFetch('sr-images', { params: { limit, offset } });
}
